



















































































import Vue from 'vue';
import { mapState } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import moment from 'moment';

moment.locale('pt-BR');

export default Vue.extend({
  components: {
    pxButton,
  },
  data: function() {
    return {
      refCourse: '',
      newSchool: '',
      loading: false,
      isLoadingCourses: true,
    };
  },
  computed: {
    ...mapState({
      originCourses: (state: any) =>
        state.users.schoolCourses.filter(
          course =>
            course.category &&
            (course.category.id === 4 || course.category.id === 1),
        ),
      schoolCourses: (state: any) =>
        state.users.schoolCourses.filter(
          course =>
            course.category &&
            (course.category.id === 4 || course.category.id === 35),
        ),
    }),
  },

  async created() {
    await this.$store.dispatch('PULL_SCHOOL_COURSES');
    this.isLoadingCourses = false;
  },
  methods: {
    async cloneAllWeekPlanningFromCourse() {
      if (this.refCourse.length === 0 || this.newSchool.length === 0) {
        return alert('Por favor, preencha os campos');
      }
      if (
        confirm(
          'Essa operação apagará o planejamento atual do Curso Alvo e irá substitui-lo pelo da Curso Base. \n\n Deseja prosseguir com a operação?',
        )
      ) {
        this.loading = true;
        await this.$store.dispatch(
          'DELETE_DEFAULT_WEEKPLANNING_FROM_COURSE',
          this.newSchool,
        );
        await this.$store.dispatch('CLONE_ALL_WEEKPLANNINGS_FROM_COURSE', {
          courseFromId: this.refCourse,
          courseToId: this.newSchool,
        });
        this.loading = false;
        alert('Operação realizada com sucesso!');
      }
    },
  },
});
